import { render, staticRenderFns } from "./surfaceHome.vue?vue&type=template&id=b174b4aa&scoped=true&"
import script from "./surfaceHome.vue?vue&type=script&lang=js&"
export * from "./surfaceHome.vue?vue&type=script&lang=js&"
import style0 from "./surfaceHome.vue?vue&type=style&index=0&id=b174b4aa&prod&lang=less&scoped=true&"
import style1 from "./surfaceHome.vue?vue&type=style&index=1&id=b174b4aa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b174b4aa",
  null
  
)

export default component.exports